export default __webpack_public_path__ + "static/media/Helm of the Martial Paragon.c29ed17b.jpg";